import { render, staticRenderFns } from "./ReasonPoint.vue?vue&type=template&id=e0409fee&scoped=true&"
import script from "./ReasonPoint.vue?vue&type=script&lang=js&"
export * from "./ReasonPoint.vue?vue&type=script&lang=js&"
import style0 from "./ReasonPoint.vue?vue&type=style&index=0&id=e0409fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0409fee",
  null
  
)

export default component.exports